var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSubscriptionSuccessfull(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-10"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.4,337.8H45.3a5.71,5.71,0,0,1-5.71-5.71V60.66A5.71,5.71,0,0,1,45.3,55H238.4a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,238.4,337.8ZM45.3,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46H238.4a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.7,337.8H261.6a5.71,5.71,0,0,1-5.71-5.71V60.66A5.71,5.71,0,0,1,261.6,55H454.7a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,454.7,337.8ZM261.6,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46H454.7a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164.95,
    cy: 88.11,
    r: 15.45,
    transform: "translate(-14.77 139.79) rotate(-44.15)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166.7,
    cy: 88.73,
    r: 15.45,
    transform: "translate(-21.94 79.82) rotate(-25.32)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.59,92.63a11.57,11.57,0,1,1-7-14.79A11.57,11.57,0,0,1,177.59,92.63Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.32,91.7A3.46,3.46,0,0,0,171.06,90a3.14,3.14,0,0,0,2.61-2.12,2.92,2.92,0,0,0-.37-2.78,5.25,5.25,0,0,0-2.08-1.65l.32-.89-1.38-.49-.3.83-1.37-.49.29-.83-1.37-.5-.3.83-3-1.06-4.41,12.33,3,1.06-.31.88,1.38.49.31-.88,1.37.5-.31.87,1.38.49.32-.91a6.19,6.19,0,0,0,3.24.22,3,3,0,0,0,2.15-2A3.33,3.33,0,0,0,172.32,91.7ZM166.2,84,169,85a3,3,0,0,1,1.47.93,1.43,1.43,0,0,1-.77,2.17,3,3,0,0,1-1.74-.2l-2.83-1Zm2.28,9.46a3.34,3.34,0,0,1-1.83-.24L163.32,92l1.09-3,3.33,1.19c1.52.54,2.09,1.32,1.73,2.34A1.36,1.36,0,0,1,168.48,93.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.53,96.09v4.62a13.77,13.77,0,0,1,7.84,3.25l3.26-3.27A18.33,18.33,0,0,0,242.53,96.09Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.3,128.27a13.83,13.83,0,0,1-12.67-12.66H223a18.42,18.42,0,0,0,17.29,17.28Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.63,113.38a13.83,13.83,0,0,1,12.67-12.67V96.09A18.43,18.43,0,0,0,223,113.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.21,102.27l-3.27,3.27a13.81,13.81,0,0,1-9.41,22.73v4.62a18.43,18.43,0,0,0,12.68-30.62Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.19 150.82 85.62 161.09 110.24 154.46 122.43 139.3 136.14 134.15 137.5 137.78 147.9 126.59 132.24 121.56 133.79 125.67 120.11 130.61 108.35 146.12 85.19 150.82",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.06,161.28a16.27,16.27,0,1,1-22.16-6.21A16.27,16.27,0,0,1,392.06,161.28Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 379.57,
    cy: 168.3,
    r: 16.27,
    transform: "translate(-12.77 304.18) rotate(-43.01)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 379.57,
    cy: 168.3,
    r: 12.18,
    transform: "translate(67.42 442.08) rotate(-65.17)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.5,167.94c1.73,2.11,1,4.59-1.76,6.47l1,2-1.76,1-1-2a11.18,11.18,0,0,1-5.06,1l-.43-2.63a9.24,9.24,0,0,0,4.26-.75l-1.6-3c-2,.47-4.28.9-5.86-1-1.72-2.11-1-4.63,1.87-6.5l-1-2,1.76-1,1.06,2a10.2,10.2,0,0,1,4-.92l.53,2.58a7.94,7.94,0,0,0-3.3.65l1.67,3.15C381.79,166.52,384,166.11,385.5,167.94Zm-7.72-.45-1.36-2.57c-.86.74-1,1.55-.55,2.16S377,167.61,377.78,167.49ZM383,170a1.78,1.78,0,0,0-1.8-.38l1.3,2.44C383.29,171.31,383.48,170.56,383,170Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.58 71.62 308.24 97.08 323.58 106.35 323.58 71.62",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "308.24 97.08 323.58 90.2 323.58 106.35 308.24 97.08",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.58 71.62 338.92 97.08 323.58 106.35 323.58 71.62",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "338.92 97.08 323.58 90.2 323.58 106.35 338.92 97.08",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "308.19 101.72 323.63 123.48 323.58 110.92 308.19 101.72",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "338.97 101.72 323.52 123.48 323.58 110.92 338.97 101.72",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-10"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-10",
    cx: 252.14,
    cy: 415.69,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Rocket--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.56,414.88H74a20.74,20.74,0,0,1-6.25-26.94,11.68,11.68,0,0,1,4-4.46,20.53,20.53,0,0,1-1.92-14c1.06-4.47,4.76-7.5,8.58-9.94a68.66,68.66,0,0,1,9-47.38c8.58-13.94,22.73-23,38.29-27.41a42.87,42.87,0,0,1,42-47.94,29.38,29.38,0,0,1,12.65-21.18A28,28,0,0,1,204.27,212a20.19,20.19,0,0,1,10.8-14,19.54,19.54,0,0,1,17.49.41c8.18-2.32,17.18,2.05,20.89,9.83s1.23,18.1-5.62,23.23c7.73,11.52,7.39,29.56-.82,40.73,4.52,1.22,6.48,7.7,7.15,12.42a67.52,67.52,0,0,1-6.68,40.05c8.34-.4,16.41,5.82,21.38,12.66a26.89,26.89,0,0,1,3.53,24.24c4.84-.3,8.95,3.53,11.33,7.82a33.94,33.94,0,0,1,3.38,11.37,5.68,5.68,0,0,1,.43,1.24C290.12,393.38,286.13,406.91,277.56,414.88Z",
    style: {
      fill: "#6C5DD3"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.56,414.88H74a20.74,20.74,0,0,1-6.25-26.94,11.68,11.68,0,0,1,4-4.46,20.53,20.53,0,0,1-1.92-14c1.06-4.47,4.76-7.5,8.58-9.94a68.66,68.66,0,0,1,9-47.38c8.58-13.94,22.73-23,38.29-27.41a42.87,42.87,0,0,1,42-47.94,29.38,29.38,0,0,1,12.65-21.18A28,28,0,0,1,204.27,212a20.19,20.19,0,0,1,10.8-14,19.54,19.54,0,0,1,17.49.41c8.18-2.32,17.18,2.05,20.89,9.83s1.23,18.1-5.62,23.23c7.73,11.52,7.39,29.56-.82,40.73,4.52,1.22,6.48,7.7,7.15,12.42a67.52,67.52,0,0,1-6.68,40.05c8.34-.4,16.41,5.82,21.38,12.66a26.89,26.89,0,0,1,3.53,24.24c4.84-.3,8.95,3.53,11.33,7.82a33.94,33.94,0,0,1,3.38,11.37,5.68,5.68,0,0,1,.43,1.24C290.12,393.38,286.13,406.91,277.56,414.88Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M228.72,181.62l62.91-10.21a1.27,1.27,0,0,1,1.37,1.72L269.07,232.2a1.25,1.25,0,0,1-2.15.31l-39-48.86A1.26,1.26,0,0,1,228.72,181.62Z",
    style: {
      fill: "#6C5DD3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.72,181.62l62.91-10.21a1.27,1.27,0,0,1,1.37,1.72L269.07,232.2a1.25,1.25,0,0,1-2.15.31l-39-48.86A1.26,1.26,0,0,1,228.72,181.62Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.21,205.45l3.92-5.07-3.41-4.28-5.82,2.7A11.08,11.08,0,0,0,233.21,205.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.72,196.1l-1.37.63a11.12,11.12,0,0,0,3.86,4.84l.92-1.19Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.89,197.41l-1.09.51a12.69,12.69,0,0,0,4.69,5.87l.73-.95A18.07,18.07,0,0,1,230.89,197.41Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.37,202.48a15,15,0,0,1-7.21-9l36.17-28.86a19.63,19.63,0,0,1,14.51-4.18,19.61,19.61,0,0,1-7.3,13.21Z",
    style: {
      fill: "#6C5DD3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.33,164.59,234.24,191.8a17.61,17.61,0,0,0,7.2,9l34.1-27.21a19.61,19.61,0,0,0,7.3-13.21A19.63,19.63,0,0,0,268.33,164.59Z",
    style: {
      fill: "#6C5DD3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.33,164.59,234.24,191.8a17.61,17.61,0,0,0,7.2,9l34.1-27.21a19.61,19.61,0,0,0,7.3-13.21A19.63,19.63,0,0,0,268.33,164.59Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.33,164.59l-1.56,1.25a21,21,0,0,0,7.2,9l1.57-1.25a19.61,19.61,0,0,0,7.3-13.21A19.63,19.63,0,0,0,268.33,164.59Z",
    style: {
      fill: "#6C5DD3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.33,164.59l-1.56,1.25a21,21,0,0,0,7.2,9l1.57-1.25a19.61,19.61,0,0,0,7.3-13.21A19.63,19.63,0,0,0,268.33,164.59Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.22,227.77l3.92-5.08-3.41-4.27-5.81,2.7A11.06,11.06,0,0,0,252.22,227.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.73,218.42l-1.36.63a11,11,0,0,0,3.86,4.83l.91-1.19Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.91,219.73l-1.09.5a12.64,12.64,0,0,0,4.68,5.88l.74-1A17.92,17.92,0,0,1,249.91,219.73Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.39,224.8a15.07,15.07,0,0,1-7.21-9l36.17-28.86a19.68,19.68,0,0,1,14.51-4.19,19.73,19.73,0,0,1-7.3,13.22Z",
    style: {
      fill: "#6C5DD3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.35,186.91l-34.1,27.2a17.64,17.64,0,0,0,7.21,9l34.1-27.2a19.73,19.73,0,0,0,7.3-13.22A19.68,19.68,0,0,0,287.35,186.91Z",
    style: {
      fill: "#6C5DD3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.35,186.91l-34.1,27.2a17.64,17.64,0,0,0,7.21,9l34.1-27.2a19.73,19.73,0,0,0,7.3-13.22A19.68,19.68,0,0,0,287.35,186.91Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.35,186.91l-1.56,1.24a21,21,0,0,0,7.2,9l1.57-1.25a19.73,19.73,0,0,0,7.3-13.22A19.68,19.68,0,0,0,287.35,186.91Z",
    style: {
      fill: "#6C5DD3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.35,186.91l-1.56,1.24a21,21,0,0,0,7.2,9l1.57-1.25a19.73,19.73,0,0,0,7.3-13.22A19.68,19.68,0,0,0,287.35,186.91Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.09,220.44l6.34-8.18-5.51-6.91-9.39,4.36A17.84,17.84,0,0,0,242.09,220.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.92,205.35l-2.2,1a17.83,17.83,0,0,0,6.22,7.8l1.49-1.91Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.36,207.47l-1.77.82a20.48,20.48,0,0,0,7.57,9.48l1.19-1.54A29,29,0,0,1,238.36,207.47Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252,215.65a24.3,24.3,0,0,1-11.63-14.58l58.39-46.59a31.77,31.77,0,0,1,23.42-6.75,31.73,31.73,0,0,1-11.78,21.33Z",
    style: {
      fill: "#6C5DD3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.8,154.48l-55,43.92A28.45,28.45,0,0,0,255.39,213l55.05-43.92a31.73,31.73,0,0,0,11.78-21.33A31.77,31.77,0,0,0,298.8,154.48Z",
    style: {
      fill: "#6C5DD3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.8,154.48l-55,43.92A28.45,28.45,0,0,0,255.39,213l55.05-43.92a31.73,31.73,0,0,0,11.78-21.33A31.77,31.77,0,0,0,298.8,154.48Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.8,154.48l-2.52,2a33.91,33.91,0,0,0,11.63,14.58l2.53-2a31.73,31.73,0,0,0,11.78-21.33A31.77,31.77,0,0,0,298.8,154.48Z",
    style: {
      fill: "#6C5DD3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.8,154.48l-2.52,2a33.91,33.91,0,0,0,11.63,14.58l2.53-2a31.73,31.73,0,0,0,11.78-21.33A31.77,31.77,0,0,0,298.8,154.48Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.33,175.34a5.43,5.43,0,1,1,.86-7.64A5.44,5.44,0,0,1,296.33,175.34Z",
    style: {
      fill: "#6C5DD3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.69,174.48a5.43,5.43,0,0,1,.55-7.36,3.43,3.43,0,0,0-.33.24,5.43,5.43,0,1,0,6.78,8.49l.3-.27A5.43,5.43,0,0,1,288.69,174.48Z",
    style: {
      fill: "#6C5DD3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.69,174.48a5.43,5.43,0,0,1,.55-7.36,3.43,3.43,0,0,0-.33.24,5.43,5.43,0,1,0,6.78,8.49l.3-.27A5.43,5.43,0,0,1,288.69,174.48Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.33,174.09a3.84,3.84,0,1,1,.61-5.39A3.82,3.82,0,0,1,295.33,174.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.83,173.32l6.76-3.39a3.84,3.84,0,0,0-.6-1.15l-6.74,3.37A4,4,0,0,0,289.83,173.32Z",
    style: {
      fill: "#6C5DD3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.88,174.31l5.88-2.94a3.47,3.47,0,0,0,0-.72l-6.43,3.22A4,4,0,0,0,290.88,174.31Z",
    style: {
      fill: "#6C5DD3"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.83,173.32l6.76-3.39a3.84,3.84,0,0,0-.6-1.15l-6.74,3.37A4,4,0,0,0,289.83,173.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.88,174.31l5.88-2.94a3.47,3.47,0,0,0,0-.72l-6.43,3.22A4,4,0,0,0,290.88,174.31Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bars--inject-10"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 308.52,
    y: 234.34,
    width: 53.74,
    height: 180.4,
    style: {
      fill: "#6C5DD3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.39,
    y: 234.32,
    width: 15.18,
    height: 180.32,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.89,
    y: 364.57,
    width: 53.74,
    height: 50.18,
    style: {
      fill: "#6C5DD3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.39,
    y: 364.52,
    width: 15.18,
    height: 50.13,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.91,
    y: 321.16,
    width: 53.74,
    height: 93.58,
    style: {
      fill: "#6C5DD3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.54,
    y: 321.12,
    width: 15.18,
    height: 93.53,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.49,
    y: 277.75,
    width: 53.74,
    height: 136.99,
    style: {
      fill: "#6C5DD3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.24,
    y: 277.72,
    width: 15.18,
    height: 136.93,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.54,
    y: 190.93,
    width: 53.74,
    height: 223.81,
    style: {
      fill: "#6C5DD3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.54,
    y: 190.93,
    width: 15.18,
    height: 223.72,
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-10"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "171.92 291.84 167.48 306.99 174.02 308.52 179 294.02 171.92 291.84",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.49,306.77,168,305.32a.64.64,0,0,0-.69.4l-2.69,6.3a1.09,1.09,0,0,0,.49,1.44l.21.07c2.72.47,5.17.77,8.55,1.42,4,.77,2.87,1.09,7.55,2.06,2.81.58,4-2.76,2.87-3.16-5.34-1.79-5.55-3.67-7.24-6.18A2.37,2.37,0,0,0,175.49,306.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.55 192.95 162.36 208.75 135.32 213.49 136.55 192.95",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.92,301.36l-9.32-1.67s3.47-12.92,7.23-30.58c.58-2.72,8.07-23.42,8.07-23.42s-37-17.34-37.59-17.53c-.47-.15-3.5-.38-8.23-4.08-8.8-6.88-6-20.34-6-20.34l23,.55c22.45,12,41.94,29.53,44.57,36.71C203.35,251.11,177.92,301.36,177.92,301.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.57 285.09 70.2 288.71 72.11 295.16 87.17 292.32 85.57 285.09",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.35,295.56l-2.46-7.26a.66.66,0,0,0-.69-.41l-6.81.78a1.08,1.08,0,0,0-1,1.14.78.78,0,0,0,0,.21c.94,2.6,1.88,4.88,3,8.14,1.31,3.85.48,3,2,7.58.88,2.74,4.39,2.14,4.16.93-1.08-5.52.45-6.63,1.8-9.34A2.36,2.36,0,0,0,74.35,295.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.26,295l-3.15-8.92L126,258.83s-3.19-40.71-3.34-41.34-1.4-3.23-.52-9.18c1.63-11,14.69-15.29,14.69-15.29L148,216.59s-5.19,47.78-10.13,53.61C130.92,278.41,80.26,295,80.26,295Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.31 228.16 138.08 224.08 144.42 243.6 146.31 228.16",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,164.08c-4.24.91-8.5,1.72-12.76,2.51l-3.2.58-2.85.49a6.77,6.77,0,0,0-3.28,1.74L139.42,174c-1.5,1.56-3,3.12-4.53,4.65-3,3.08-6.1,6.15-9.22,9.17a2.75,2.75,0,0,1-4.16-3.56c2.48-3.55,5-7,7.6-10.52,1.27-1.76,2.57-3.48,3.87-5.2l4-5.27a15.91,15.91,0,0,1,7.53-5.05l3.46-.94,3.12-.82c4.17-1.06,8.33-2.12,12.52-3.08A5.5,5.5,0,0,1,166,164.07Z",
    style: {
      fill: "#6C5DD3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,164.08c-4.24.91-8.5,1.72-12.76,2.51l-3.2.58-2.85.49a6.77,6.77,0,0,0-3.28,1.74L139.42,174c-1.5,1.56-3,3.12-4.53,4.65-3,3.08-6.1,6.15-9.22,9.17a2.75,2.75,0,0,1-4.16-3.56c2.48-3.55,5-7,7.6-10.52,1.27-1.76,2.57-3.48,3.87-5.2l4-5.27a15.91,15.91,0,0,1,7.53-5.05l3.46-.94,3.12-.82c4.17-1.06,8.33-2.12,12.52-3.08A5.5,5.5,0,0,1,166,164.07Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.66,184.2l-6.6,2.56,6,5.78,5-4a1.31,1.31,0,0,0,.17-1.9A6.71,6.71,0,0,0,120.66,184.2Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.06,186.76l-1,1.92a2.23,2.23,0,0,0,.58,2.81l2.12,1.66a2.22,2.22,0,0,0,2.27.29l2-.9Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.42,212.93l-2.43-.4,1.51-1.83,30.41-10.92c4.84-1.74,8-5,5.5-10.92-2.31-5.5-7.51-7.13-12.34-5.41L76.66,194.24l-2.46-.46L75.73,192l30.42-10.77c5.62-2,11-1.54,14.69,7.1s-.38,11.61-6,13.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.43,179.93l-.67-1.51a6.81,6.81,0,0,0-8.18-3.76L62.15,181.4l4,9.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.43,179.93l-.67-1.51a6.81,6.81,0,0,0-8.18-3.76L62.15,181.4l4,9.91Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.72,216.49l-.93-2.23,29.49-13c4.69-2.06,7.71-5.63,5.23-11.52-2.31-5.51-7.39-6.88-12.08-4.84L77.94,197.76,77,195.54l29.49-12.83c5.46-2.37,10.75-2.22,14.39,6.44s-.23,11.93-5.68,14.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.36,230.42,64.18,186.48l22-9.39a5.43,5.43,0,0,1,7.21,2.84l13.35,31.94a7.32,7.32,0,0,1-3.83,9.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.72,216.49l-2.37-.28,1.44-2,29.49-13c4.69-2.06,7.71-5.63,5.23-11.52-2.31-5.51-7.39-6.88-12.08-4.84L77.94,197.76l-2.4-.33L77,195.54l29.49-12.83c5.46-2.37,10.75-2.22,14.39,6.44s-.23,11.93-5.68,14.33Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "89.61 193.41 88.09 189.76 89.45 189.16 90.98 192.82 89.61 193.41",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.75 197.28 79.22 193.61 80.59 193.01 82.12 196.68 80.75 197.28",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.45 212.21 95.92 208.53 97.28 207.93 98.81 211.6 97.45 212.21",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88.58 216.12 87.05 212.44 88.42 211.83 89.95 215.51 88.58 216.12",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.47,147.39c.29.14.35.61.13,1s-.62.68-.9.54-.34-.61-.13-1.05S200.19,147.24,200.47,147.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.27,147.73a1.6,1.6,0,0,0,1.09-.18,1.43,1.43,0,0,1-1.05-.32A.55.55,0,0,1,200.27,147.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.78,151.9a2.81,2.81,0,0,0,2.28.64,17.67,17.67,0,0,1-.25-4.76Z",
    style: {
      fill: "#ff5652"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.89,145.15a2.26,2.26,0,0,1,2,.5h0l.06.07a.29.29,0,0,0,.41-.06.28.28,0,0,0-.06-.4,2.79,2.79,0,0,0-2.49-.7.27.27,0,0,0-.17.1.3.3,0,0,0,0,.41A.32.32,0,0,0,198.89,145.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.93,165.59c-6.48-5-4.7-9.28-4.7-9.28,3.39-.36,6.19-3.71,8.19-7.08a9.22,9.22,0,0,0,.47,3.33c.73,2.22,5.34,3.23,5.34,3.23s-.45.57-1,1.42c-1.48,2.09-3.81,5.95-2.42,7.93C184.76,165.14,186.06,171.1,178.93,165.59Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.92,156.39c-.3.24-.6.48-.89.76a.15.15,0,0,1-.1,0,7.45,7.45,0,0,1-4-4.55,9.06,9.06,0,0,1-.47-3.34c.52-.85,1-1.72,1.38-2.52l4,9.34Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.66,154.78a8.33,8.33,0,0,1-7.48,3h0a7,7,0,0,1-2.11-.58.15.15,0,0,1-.1,0,7.45,7.45,0,0,1-4-4.55,9.06,9.06,0,0,1-.47-3.34c.11-2.72,1.4-5.43,3.06-9.38a8.15,8.15,0,0,1,13.68-2.34C203.36,142.22,200.18,150.52,196.66,154.78Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.73,157.6a4.21,4.21,0,0,1-1.55-.39c.6-.85,1.06-1.41,1-1.42l1.23-1.36S188.39,157.33,188.73,157.6Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.88,144.69c-1.17.42-3.37-.18-3.16-.32.82-.47,1.81-1.83.72-2.2-.18.72-2.61,5.24-3.31,5.46-.38.13-3,3.16-6.61,4.89-2.83,1.38-3.38,2.07-3.38,2.07l-5-2.61c-1.48-1.5-5.05-14.93,2.52-17.49,2.48-.84,4.38-2.94,8.32-1.81,2.43.7,5.28.27,7.67,1.1a7.83,7.83,0,0,1,5.24,5.07C205.16,140.05,204.84,143.65,201.88,144.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.32,145.77c1,1.46.17,4-.77,5.32s-2.67,1.59-3.15-.31a6.82,6.82,0,0,1,.39-4.32C194.54,144.84,196.28,144.31,197.32,145.77Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--group--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.56,157.17s3.43-2.29,5.7-2.07,8.08,6.44,8.8,7.66-.13,4.43-.13,4.43Z",
    style: {
      fill: "#6C5DD3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.56,157.17s3.43-2.29,5.7-2.07,8.08,6.44,8.8,7.66-.13,4.43-.13,4.43Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.68,167.77a28.39,28.39,0,0,0-2.16-2.38,117.8,117.8,0,0,0-10.72-8.29,29.65,29.65,0,0,0-4.28-2.33,6.77,6.77,0,0,0-8.44,2.34c-5.17,7.64-6.39,13.57-9.83,18.57a97.48,97.48,0,0,1-15.62,17.42l4.28,4.58a62.71,62.71,0,0,0,22.45,11.07h0s7.79-12.44,12.26-15.61C186.83,184.47,186.1,181,188,177.25A8.41,8.41,0,0,0,186.68,167.77Z",
    style: {
      fill: "#6C5DD3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188,177.26c-.68,1.33-1,2.65-1.75,4.18a21.54,21.54,0,0,1-5.63,7,66.2,66.2,0,0,1-6,4.71,29,29,0,0,0-5,5.3l0,0a6.43,6.43,0,0,0-.4,7.35c3.17,5.17,8,12.55,8,12.55-3.44-.9-4.84-1.27-10.31.46-8.56,2.7-26.51.32-31.57-6.91a23.25,23.25,0,0,1,6.22-8.8,47.27,47.27,0,0,0-8.57,7.28c-2.26.47-4.55-.77-6.18-2.38s-2.85-3.63-4.42-5.3-3.29-3.25-5.58-3.05c3-4,8.07-5.64,12.84-7,3.56-1,8.1-2.5,11.5-4.75a89.12,89.12,0,0,0,10.13-12.19c3.43-5,4.64-10.93,9.83-18.58a6.76,6.76,0,0,1,8.44-2.34,29.81,29.81,0,0,1,4.28,2.34,120.27,120.27,0,0,1,10.71,8.27,30.09,30.09,0,0,1,2.16,2.39A8.44,8.44,0,0,1,188,177.26Z",
    style: {
      fill: "#6C5DD3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.31,164.21l5.15-2.23a3,3,0,0,0,.6-.35l2.32-1.81a1,1,0,0,0,.35-1.08L241.38,155a1.15,1.15,0,0,0-1.28-.86l-3.48,1.3a1.65,1.65,0,0,0-.68.46l-3.49,3.8a1.27,1.27,0,0,0-.17,1.28l1.54,2.44A1.23,1.23,0,0,0,235.31,164.21Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.61,188.42l2.22-12.1,4.7,2.53C185.87,183.24,183.92,185.48,180.61,188.42Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.58,180.06c6.42-4.46,14.48-10.76,20.36-15.83.55-1.94-1.28-4.49-3.14-3.71-4.63,1.94-18.46,9.61-20.9,9.68-1.68.05-19-2.45-24.66-3.27a4.63,4.63,0,0,0-3.23.69c-3.13,2.12-3.93,4.44-3.75,6.48a6.64,6.64,0,0,0,6.21,5.86c7.91.59,19.77,1.25,24.39,1.45A7.62,7.62,0,0,0,214.58,180.06Z",
    style: {
      fill: "#6C5DD3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.87,149.63c-1.82,5.23-4.26,15.21-8.27,19s-9.64,4-15,5.26c-1.29.32-2.94,1.95-2.92,1.69a9.71,9.71,0,0,0-2.41,5.32l-5.83-4.55a4.27,4.27,0,0,1-1.4-1.53,3.58,3.58,0,0,1,.65-3.33,18.19,18.19,0,0,0,1.76-3.89,12.44,12.44,0,0,0-4.34,6c-2.84-1-6.16-3.39-6.22-6.41a8.53,8.53,0,0,1,2.71-6.39,10.79,10.79,0,0,0-4.6,4.71c-.61-1.79-2.1-3.57-4-3.51a41,41,0,0,1,5.55-9c2.34-2.63,5.53-4.7,9-4.94,2.68-.19,5.31.68,7.87,1.49s5.22,1.6,7.88,1.26,5.4-4.42,5.9-7.06C183,141.57,188.34,146.93,192.87,149.63Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M210.59,144.87A19.62,19.62,0,0,1,190,163.46h-.07a19.43,19.43,0,0,1-2.43-.3,38.29,38.29,0,0,0-14.91-12.5,19.1,19.1,0,0,1-.68-2.3,19.61,19.61,0,1,1,38.68-3.49Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.65,162.34a19.61,19.61,0,0,1-7.64,1.12h-.07a19.14,19.14,0,0,1-2.44-.3,38.22,38.22,0,0,0-14.91-12.5,17.44,17.44,0,0,1-.68-2.3,19.6,19.6,0,0,1,14.81-23.63h0a8.54,8.54,0,0,1,2.94,2.42,16.36,16.36,0,0,1,2.86,7.94,41.18,41.18,0,0,1-.3,12.92,15,15,0,0,0,.82,8.73C195,161.18,197.65,162.34,197.65,162.34Z",
    style: {
      fill: "#6C5DD3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.65,162.34a19.61,19.61,0,0,1-7.64,1.12h-.07a19.14,19.14,0,0,1-2.44-.3,38.22,38.22,0,0,0-14.91-12.5,17.44,17.44,0,0,1-.68-2.3,19.6,19.6,0,0,1,14.81-23.63h0a8.54,8.54,0,0,1,2.94,2.42,16.36,16.36,0,0,1,2.86,7.94,41.18,41.18,0,0,1-.3,12.92,15,15,0,0,0,.82,8.73C195,161.18,197.65,162.34,197.65,162.34Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.69,164.9a.89.89,0,0,1-1.28-.09c-.32-.52-.66-1-1-1.54a38.09,38.09,0,0,0-14.72-12.72c-.61-.31-1.22-.59-1.83-.86s-.45-1,0-1.41a1,1,0,0,1,1.17,0,.83.83,0,0,1,.33.34,44.72,44.72,0,0,1,17.49,15,.08.08,0,0,0,0,0A1,1,0,0,1,189.69,164.9Z",
    style: {
      fill: "#6C5DD3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.8,145.52a1.73,1.73,0,1,1-1.73-1.73A1.73,1.73,0,0,1,193.8,145.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.38,146a1.74,1.74,0,1,1-1.73-1.73A1.74,1.74,0,0,1,194.38,146Z",
    style: {
      fill: "#6C5DD3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.38,146a1.74,1.74,0,1,1-1.73-1.73A1.74,1.74,0,0,1,194.38,146Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Target--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M438.31,104.13a24.55,24.55,0,0,1-24.55,24.55c-.55,0-1.09,0-1.64-.06a24.55,24.55,0,0,1,0-49c.55,0,1.09,0,1.64,0A24.55,24.55,0,0,1,438.31,104.13Z",
    style: {
      fill: "#6C5DD3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435,104.13a23,23,0,1,1-22.91-24.5A24.54,24.54,0,0,1,435,104.13Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 412.07,
    cy: 104.13,
    r: 18.37,
    transform: "translate(158.18 444.98) rotate(-67.5)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 412.13,
    cy: 103.99,
    r: 13.57,
    transform: "translate(-12.87 97.47) rotate(-13.28)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.56,104.13a5.3,5.3,0,1,1-5.3-5.3A5.29,5.29,0,0,1,416.56,104.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "374.44 122.34 379.35 123.14 386.55 118.89 386.55 118.88 382.88 117.26 374.44 122.34",
    style: {
      fill: "#6C5DD3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.99,
    y: 114.13,
    width: 33.98,
    height: 0.73,
    transform: "translate(-3.39 216.6) rotate(-30.62)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "378.72 127.53 385.82 123.32 386.55 118.89 379.35 123.14 378.72 127.53",
    style: {
      fill: "#6C5DD3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "378.72 127.53 385.82 123.32 386.55 118.89 379.35 123.14 378.72 127.53",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.49 103.86 405.61 105.11 410.06 107.56 412.07 104.37 410.49 103.86",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413,72.78A1.81,1.81,0,0,1,411.14,71v-8a1.82,1.82,0,1,1,3.64,0v8A1.81,1.81,0,0,1,413,72.78Z",
    style: {
      fill: "#6C5DD3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413,147.17a1.81,1.81,0,0,1-1.82-1.82v-8a1.82,1.82,0,1,1,3.64,0v8A1.81,1.81,0,0,1,413,147.17Z",
    style: {
      fill: "#6C5DD3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.88,104.81h-8.05a1.83,1.83,0,1,1,0-3.65h8.05a1.83,1.83,0,1,1,0,3.65Z",
    style: {
      fill: "#6C5DD3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.14,104.81h-8.06a1.83,1.83,0,0,1,0-3.65h8.06a1.83,1.83,0,0,1,0,3.65Z",
    style: {
      fill: "#6C5DD3"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionSuccessfull);
export default __webpack_public_path__ + "static/media/subscription_successfull.0e584a336041f65f8331791804b01167.svg";
export { ForwardRef as ReactComponent };